import * as React from "react";
import {
  SelectPicker,
  Row,
  Col,
  Content,
  // Alert,
  Button,
  CheckPicker,
  List,
} from "rsuite";
import { CrossSellOpportunity } from "./CrossSellOpportunity";
import { PeerBenchmarking } from "./CrossSellPeerBenchmarking";
import { CrossSellRecommendation } from "./CrossSellRecommendation";
import { CrossSellAllTogetherList } from "./CrossSellAllTogetherList";
import { Table } from "./Table";
import { UpSellOpportunity } from "./UpSellOpportunity";
import { UpSellRecommendation } from "./UpSellRecommendation";
import "./index.scss";
import "./ScenerioPage.scss";
import {
  getCrossSellCustomerList,
  getCrossSellItemListByCustomer,
  getUpSellOpportunities,
  getCrossSellItemsByCustomerOrItem,
  getCrossSellFiltersData,
  getUpSellRecommendationData,
  getUpSellLevelFourRecommendationData,
  putAPI,
  UpdateUpSellRecommendationIncudeBit,
  getTotalPageNumberForCrossSell,
  updateCrossSellUpsellDataRec,
  getCrossSellL4DataByCustomer,
  acceptCrossSellRecommendation,
  getCrossSellCustomerFilter,
  saveCrossSellItemVolume,
  rejectCrossSellRecommendation,
} from "../../queries/apiQueries";
import Title from "./Title";
import { CrossSellOpportunityL4 } from "./CrossSellOpportunityL4";
// import { appInsights } from "../../pages/Router";
import { Box, Modal } from "@mui/material";
import { initial } from "lodash";

export class CrossSell extends React.Component<any, any> {
  sortObj = {
    field: "opport",
    isAsc: false,
  };
  clickedCustomerData: any;
  backupClickedCustomerData: any = null;
  clickedCustomerIndex: any = null;
  backupSelectedCategory: any = null;
  saveRequestPayload: any = {
    summary: {},
    item: {},
  };
  arrayToBeUsed: any[] = [];
  selectedCustomer: any = "";
  /* Golden copy of entire dataset which won't change */
  masterCustomers: any = [];
  masterSKU: any = [];
  masterRecommendedSKU: any = [];
  masterData: any = [];
  constructor(props: any) {
    super(props);
    this.state = {
      userEmail: localStorage.getItem("user_email"),
      pageLoading: false,
      divisionData: [],
      divsionTableSUmmaryData: {},
      tableData: [],
      filterData: [],
      filteredList: {},
      crossInfo: { length: 0, opport: 0 },
      upInfo: { length: 0, opport: 0 },
      enableSave: false,
      tableHeight: 250,
      openPopUp: false,
      openTrendPopUp: false,
      historicalTrendData: [],
      selectedCustomer: null,
      isUpSell: false,
      crossSellOpportunityData: null,
      crossSellItemList: [],
      GoTogetherItemList: [],
      itemsTotal: {},
      recAcceptedObj: {},
      powerBiSelectedCustomer: "",
      selectedSubCategoryData: null,
      peerItemLevelData: {},
      divisionFilter: [],
      upSellOpportunityData: null,
      upSellRecommendedData: null,
      upSellLevelFourRecommendedData: null,
      handleClick: null,
      dataToBeSave: null,
      selectedLFourValue: "",
      isRowHighlightedRequired: null,
      isRowHighlighted: true,
      isUpSellRowHighlightingRequired: null,
      isUpSellRowHighlighted: true,
      isGoBackLinkVisible: false,
      setGoBackLinkValue: null,
      setAdjustPoistionIconValue: null,
      adjustPositionValue: 0,
      resettingValueWithIncludeBitForUpSell: null,
      expendedRow: [],
      setExpendedRowArray: null,
      backupTableData: null,
      handlePaginationAPI: null,
      orderBy: "marginOpportunity",
      order: "desc",
      pageSize: 10,
      pageNumber: 1,
      totalCount: 0,
      totalOpp: "",
      setPayloadVariables: null,
      isInputValManipulated: false,
      openOpportunityPopup: false,
      l4Data: { list: [] },
      selectedL4Data: null,
      openModal: false,
      CustomerFilterValue: [],
      PeerFilterValue: [],
      SelectedCustomerFilter: null,
      CustomerFilterSelectedValue: {
        projectFlag: ["NonProject"],
        initialPeerGroupName: [],
        peerGroupName: [],
        customer: [],
        userEmail: localStorage.getItem("user_email"),
      },
      PeerGroupName: null,
      /* Copy of data that may update as per cascading filters */
      allCustomers: [],
      allItemId: [],
      allRecommendedItemId: [],
      allDistricts: [],
      selectedDistrict: [],
      selectedCustomersList: [],
      selectedItemIdBought: [],
      selectedRecommendedItemIdBought: [],
      exportData: [],
      setBackToOriginalData: [],
      saveRecommendation: {},
    };
  }

  handleModalClose = () => {
    this.setState({
      openOpportunityPopup: false,
    });
  };

  proceedWithHandleYes = () => {
    this.getCustomerList(
      this.state.CustomerFilterSelectedValue.customer,
      this.state.CustomerFilterSelectedValue.peerGroupName,
      this.state.CustomerFilterSelectedValue.projectFlag,
      this.state.pageSize,
      this.state.PageNumber,
      this.state.order,
      this.state.orderBy,
      this.state.isUpSell
    );
    this.handleModalClose();
    this.setState({
      isInputValManipulated: false,
    });
  };

  setPayloadVariables = (
    customerDesc: any,
    peerGroupName: any,
    projectFlag: any,
    order: any,
    orderBy: any,
    pageSize: any,
    PageNumber: any,
    isUpSell: AnalyserNode
  ) => {
    this.setState({
      order: order,
      orderBy: orderBy,
      pageSize: pageSize,
      PageNumber: PageNumber,
    });
    if (
      orderBy === "marginOpportunity" &&
      this.state.isInputValManipulated === true
    ) {
      this.setState({
        openOpportunityPopup: true,
      });
    } else {
      this.getCustomerList(
        customerDesc,
        peerGroupName,
        projectFlag,
        pageSize,
        PageNumber,
        order,
        orderBy,
        isUpSell
      );
    }
  };

  handlePaginationAPI = (pageSize: any, PageNumber: any, isUpSell: any) => {
    // this.selectedCustomer = "";
    // let custdesc = {
    //     'customerDesc' : this.state.CustomerFilterSelectedValue
    // }
    this.setState({
      pageSize,
      PageNumber,
    });
    this.getCustomerList(
      this.state.CustomerFilterSelectedValue.customer,
      this.state.CustomerFilterSelectedValue.peerGroupName,
      this.state.CustomerFilterSelectedValue.projectFlag,
      pageSize,
      PageNumber,
      this.state.order,
      this.state.orderBy,
      isUpSell
    );
  };

  setExpendedRowArray = (val: any = []) => {
    this.setState({
      expendedRow: val,
    });
  };

  isUpSellRowHighlightingRequired = (isRequired: any) => {
    this.setState({
      isUpSellRowHighlighted: isRequired,
    });
  };

  setAdjustPoistionIconValue = (val: any) => {
    this.setState({
      adjustPositionValue: val,
    });
  };

  componentDidMount() {
    const arr: any = window.location.hash.split("?");
    if (arr.length > 1) {
      const queryParams = arr[1].split("&");
      window.localStorage.setItem("navigateTo", arr[0] + "?" + queryParams[0]);
      if (queryParams[1] == "close=true") {
        window.close();
      }
      this.setState({
        powerBiSelectedCustomer: queryParams[0]
          .split("=")[1]
          .replaceAll("%20", " "),
        isGoBackLinkVisible: true,
      });
      this.selectedCustomer = queryParams[0]
        .split("=")[1]
        .replaceAll("%20", " ");
      this.setState({
        CustomerFilterSelectedValue: {
          ...this.state.CustomerFilterSelectedValue,
          customer: this.selectedCustomer,
        },
      });
    }
    this.getCustomerFilterList();
    this.getCrossSellTotalCount(
      this.state.CustomerFilterSelectedValue,
      this.state.isUpSell
    );
    this.getCustomerList(
      this.selectedCustomer
        ? [this.selectedCustomer]
        : this.state.CustomerFilterSelectedValue.customer,
      // this.state.CustomerFilterSelectedValue.customer,
      this.state.CustomerFilterSelectedValue.peerGroupName,
      this.state.CustomerFilterSelectedValue.projectFlag,
      this.state.pageSize,
      this.state.PageNumber,
      this.state.order,
      this.state.orderBy,
      false
    );
    document.title = "Cross-Sell/Up-Sell";
    // appInsights.trackPageView({ name: "Cross-Sell" });
    // appInsights.startTrackPage("Cross-Sell");
    this.setState({
      tableHeight: window.innerHeight - 240, // minus 140 to fit into the page size
    });
    // window.addEventListener("resize", (event) => {
    //   this.setState({
    //     tableHeight: window.innerHeight - 240, // minus 140 to fit into the page size
    //   });
    // });
  }

  getCrossSellTotalCount = (payload: any, isUpSell: any) => {
    this.setState({
      pageLoading: true,
    });

    getTotalPageNumberForCrossSell(payload, (isUpSell = isUpSell))
      .then((response: any) => {
        if (response.status === 200) {
          this.setState({
            totalCount: response.data[0].count,
            totalOpp: response.data[0].opportunity,
          });
        }
      })
      .catch((err) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleFilterTable = () => {
    let pageSize = 10,
      pageNum = 1,
      order = "desc",
      orderBy = "marginOpportunity",
      isUpSell: any;

    getCrossSellCustomerList({
      pageSize: [pageSize],
      pageNumber: pageNum,
      order: order,
      orderBy: orderBy,
      isUpSell: isUpSell,
      customer: this.state.CustomerFilterSelectedValue.customer,
      peerGroupName: this.state.CustomerFilterSelectedValue.peerGroupName,
      projectFlag: this.state.CustomerFilterSelectedValue.projectFlag,
      userEmail: this.state.userEmail,
    }).then((response: any) => {
      if (response.status === 200 && response.data) {
        let newTableData = { list: [] };
        newTableData.list = response.data.data.list.map((d: any) => {
          let obj: any = {};
          let list = JSON.parse(JSON.stringify(d.list));
          let isAgreed = 1;
          d.list.forEach((d1: any) => {
            if (!obj[d1.l4]) {
              obj[d1.l4] = d1;
            } else {
              obj[d1.l4].currentPortfolio += d1.currentPortfolio;
              obj[d1.l4].currentQty += d1.currentQty;
              obj[d1.l4].currentRevenue += d1.currentRevenue;
              obj[d1.l4].marginOpportunity += d1.marginOpportunity;
              obj[d1.l4].netMargin += d1.netMargin;
              obj[d1.l4].netSales += d1.netSales;
              obj[d1.l4].quantity += d1.quantity;
            }
            if (d1.isAgreed === 0) {
              isAgreed = 0;
            }
          });
          d.isAgreed = isAgreed;
          d.listOld = list;
          d.list = Object.values(obj);
          return d;
        });
        this.setState({
          tableData: response.data.data,
          newTableData: newTableData,
          backupTableData: JSON.parse(JSON.stringify(response.data.data)),
          pageLoading: false,
          // CustomerFilterSelectedValue : []
        });
      }
    });
    this.getCrossSellTotalCount(
      this.state.CustomerFilterSelectedValue,
      this.state.isUpSell
    );
  };

  HandleCustomerFilterTable = (value: any) => {
    this.setState({
      CustomerFilterSelectedValue: {
        ...this.state.CustomerFilterSelectedValue,
        customer: value,
      },
    });
  };

  getCustomerFilterList = () => {
    this.setState({
      pageLoading: true,
    });
    getCrossSellCustomerFilter(this.state.CustomerFilterSelectedValue)
    // getCrossSellCustomerFilter()
      .then((response: any) => {
        let tempData: any = [];
        let tempData2: any = [];
        if (response.status === 200 && response.data) {
          response.data.customer.map((d: any) => {
            let obj = {
              label: `${d?.customer}-${d?.customer_desc}`,
              value: d?.customer,
            };
            tempData.push(obj);
            this.setState({
              CustomerFilterValue: tempData,
            });
          });
          response.data.peerGroupName.map((d: any) => {
            let obj = { label: d?.peerGroupName, value: d?.peerGroupName };
            tempData2.push(obj);
            this.setState({
              PeerFilterValue: tempData2,
            });
          });
        }
      })
      .catch((err) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getCustomerList = (
    customer: any,
    peerGroupName: any,
    projectFlag: any,
    pageSize = 10,
    pageNum = 1,
    order = "desc",
    orderBy = "marginOpportunity",
    isUpSell: any,
    refresh: boolean = false
  ) => {
    this.setState({
      pageLoading: true,
    });
    getCrossSellCustomerList({
      customer: customer, //{filter values as an object},
      peerGroupName: peerGroupName,
      projectFlag: projectFlag,
      pageSize: pageSize,
      pageNumber: pageNum,
      // customer:
      //   this.selectedCustomer === undefined ? "" : this.selectedCustomer,
      order: order,
      orderBy: orderBy,
      isUpSell: isUpSell,
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        if (response.status === 200 && response.data) {
          let newTableData = { list: [] };
          newTableData.list = response.data.data.list.map((d: any) => {
            let obj: any = {};
            let list = JSON.parse(JSON.stringify(d.list));
            let isAgreed = 1;
            d.list.forEach((d1: any) => {
              if (!obj[d1.l4]) {
                obj[d1.l4] = d1;
              } else {
                obj[d1.l4].currentPortfolio += d1.currentPortfolio;
                obj[d1.l4].currentQty += d1.currentQty;
                obj[d1.l4].currentRevenue += d1.currentRevenue;
                obj[d1.l4].marginOpportunity += d1.marginOpportunity;
                obj[d1.l4].netMargin += d1.netMargin;
                obj[d1.l4].netSales += d1.netSales;
                obj[d1.l4].quantity += d1.quantity;
              }
              if (d1.isAgreed === 0) {
                isAgreed = 0;
              }
            });
            d.isAgreed = isAgreed;
            d.listOld = list;
            d.list = Object.values(obj);
            return d;
          });

          if (refresh) {
            this.setState({
              crossSellOpportunityData:
                newTableData.list[this.clickedCustomerIndex],
            });
          }

          this.setState({
            tableData: response.data.data,
            newTableData: newTableData,
            backupTableData: JSON.parse(JSON.stringify(response.data.data)),
            pageLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleUpSellSave = () => {
    this.setState({
      pageLoading: true,
    });
    UpdateUpSellRecommendationIncudeBit({ data: this.arrayToBeUsed })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });

        if (response.status === 200 || response.status === 204) {
          this.arrayToBeUsed = [];
          // Alert.success("Data updated successfully");
        } else if (this.arrayToBeUsed.length === 0) {
          // Alert.error("No change happened");
        } else {
          // Alert.error("Something went wrong. Please try again after sometime");
        }

        this.getUpSellLevelFourRecommendationData({
          customer: this.state.crossSellOpportunityData.id,
          l4: this.state.selectedLFourValue,
        });
      })
      .catch((err: any) => {
        console.log("error in handleSave API --", err);
        // Alert.error("Something went wrong. Please try again after sometime");
        this.setState({
          pageLoading: false,
        });
      });
  };

  getUpSellOpportunities = (payload: any, location: any = []) => {
    this.setState({
      pageLoading: true,
    });
    getUpSellOpportunities(payload, location)
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          this.setState({
            upSellOpportunityData: response.data,
          });
        }
      })
      .catch((err) => {
        console.log("error in getUpSellOpportunity API --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getUpSellRecommendationTableData = (payload: any, location: any = []) => {
    this.setState({
      pageLoading: true,
    });
    getUpSellRecommendationData(payload, location)
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          this.setState({
            upSellRecommendedData: response.data,
          });
        }
      })
      .catch((err) => {
        console.log("error in getUpSellRecommendationData API --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getUpSellLevelFourRecommendationData = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    getUpSellLevelFourRecommendationData(payload)
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          this.setState({
            upSellLevelFourRecommendedData: response.data,
          });
        }
      })
      .catch((err) => {
        console.log("error in getUpSellLevel4Recommendation API --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getL4Data = (payload: any, event: any) => {
    this.setState({
      pageLoading: true,
    });
    getCrossSellL4DataByCustomer({
      ...payload,
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          this.setState({
            l4Data: { list: response.data.data },
          });
        }
      })
      .catch((err) => {
        console.log("error in getL4Data APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  getItemList = (payload: any, event: any) => {
    this.setState({
      pageLoading: true,
    });
    getCrossSellItemListByCustomer({
      ...payload,
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        this.setState({
          saveRecommendation: {},
        });
        let includeFlagCount: any = 0;
        let includeIndex: number = 0;
        response.data.data.itemList.forEach((d: any, index: number) => {
          d.copyQuantity = d.quantity;
          d.copyPrice = d.price;
          if (d.include === "1") {
            includeFlagCount++;
            includeIndex = index;
            const obj = {
              likelihoodOfBuying: d.likelihoodOfBuying * 100,
              peersBuying: d.peersBuying * 100,
            };
            this.setState({
              peerItemLevelData: obj,
            });
          } else {
            // d.originalQuanity = 0;
            // d.quantity = 0;
          }
        });
        if (includeFlagCount === 1) {
          response.data.data[includeIndex]["originalQuanity"] = event.quantity;
          response.data.data[includeIndex]["quantity"] = event.quantity;
        }
        if (response.status === 200 && response.data) {
          this.setState({
            crossSellItemList: response.data.data.itemList,
            itemsTotal: response.data.data.total,
          });
        }
      })
      .catch((err) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleBCISubmit = () => {};
  handleModify = () => {};
  handleRecAccept = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    acceptCrossSellRecommendation({
      ...payload,
      projectFlag: [...this.state.CustomerFilterSelectedValue.projectFlag],
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        if (response.status === 200) {
          this.getCrossSellTotalCount(
            this.state.CustomerFilterSelectedValue,
            this.state.isUpSell
          );
          this.getCustomerList(
            this.state.CustomerFilterSelectedValue.customer,
            this.state.CustomerFilterSelectedValue.peerGroupName,
            this.state.CustomerFilterSelectedValue.projectFlag,
            this.state.pageSize,
            this.state.PageNumber,
            this.state.order,
            this.state.orderBy,
            this.state.isUpSell
          );
        }
      })
      .catch((err: any) => {
        console.log("error in handleSubmit APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleRecReject = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    rejectCrossSellRecommendation({
      data: payload,
      projectFlag: [...this.state.CustomerFilterSelectedValue.projectFlag],
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        if (response.status === 200) {
          this.getCrossSellTotalCount(
            this.state.CustomerFilterSelectedValue,
            this.state.isUpSell
          );
          this.getCustomerList(
            this.state.CustomerFilterSelectedValue.customer,
            this.state.CustomerFilterSelectedValue.peerGroupName,
            this.state.CustomerFilterSelectedValue.projectFlag,
            this.state.pageSize,
            this.state.PageNumber,
            this.state.order,
            this.state.orderBy,
            this.state.isUpSell
          );
        }
      })
      .catch((err: any) => {
        console.log("error in handleSubmit APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleRecChanges = () => {
    this.getCustomerList(
      this.state.CustomerFilterSelectedValue.customer,
      this.state.CustomerFilterSelectedValue.peerGroupName,
      this.state.CustomerFilterSelectedValue.projectFlag,
      this.state.pageSize,
      this.state.PageNumber,
      this.state.order,
      this.state.orderBy,
      this.state.isUpSell,
      true
    );
  };
  sortFnLocal = () => {};
  handleTableRowClick = (event: any, index: any) => {
    this.setState({
      PeerGroupName: event.list[index].peerGroupName,
    });
    let obj: any = {};
    event.listOld.forEach((d: any) => {
      obj[d.location] = {
        label: d.location,
        value: d.location,
      };
    });
    if (index !== null) {
      this.clickedCustomerData = event;
      this.backupClickedCustomerData = event;
      this.clickedCustomerIndex = index;

      this.selectedCustomer = this.clickedCustomerData.id;
      this.setState({
        crossSellOpportunityData: this.clickedCustomerData,
        crossSellItemList: [],
        selectedSubCategoryData: null,
        divisionData: Object.values(obj),
        filteredList: event,
        divisionFilter: [],
        itemsTotal: {},
      });

      if (this.state.isUpSell) {
        this.getUpSellRecommendationTableData({
          customer: this.clickedCustomerData.id,
        });
        this.getUpSellOpportunities({ customer: this.clickedCustomerData.id });
        this.setState({
          upSellLevelFourRecommendedData: null,
        });
      }
    } else {
      this.clickedCustomerData = null;
      this.backupClickedCustomerData = null;
      this.clickedCustomerIndex = null;
      this.setState({
        crossSellOpportunityData: null,
        crossSellItemList: [],
        selectedSubCategoryData: null,
        filteredList: null,
        divisionFilter: [],
        itemsTotal: {},
      });
    }

    this.isRowHighlightedRequired(true);
    this.isUpSellRowHighlightingRequired(false);
  };

  handleL3Click = (event: any) => {
    this.handleRecChanges();
    if (
      this.state.selectedSubCategoryData &&
      this.state.selectedSubCategoryData.l4 === event.l4
    ) {
      this.setState({
        selectedSubCategoryData: null,
        l4Data: null,
      });
    } else {
      this.backupSelectedCategory = JSON.parse(JSON.stringify(event));
      this.setState({ selectedSubCategoryData: event });
      this.selectedCustomer = event.customer;
      this.getL4Data(
        {
          customer: event.customer?.replace(/&/g, "%26"),
          l3: event.l4?.replace(/&/g, "%26"),
          divisionId: this.state.divisionFilter,
          projectFlag: this.state.CustomerFilterSelectedValue.projectFlag,
          PeerGroupName: this.state.PeerGroupName,
        },
        event
      );
    }
    this.setState({
      crossSellItemList: [],
      selectedL4Data: null,
    });
  };

  handleSubCategoryClick = (event: any) => {
    if (
      this.state.selectedL4Data &&
      this.state.selectedL4Data.l4 === event.l4
    ) {
      this.setState({
        crossSellItemList: [],
        // selectedSubCategoryData: null,
        selectedL4Data: null,
      });
    } else {
      // this.backupSelectedCategory = JSON.parse(JSON.stringify(event));
      this.setState({ selectedL4Data: event });
      // this.selectedCustomer = event.customer;
      this.getItemList(
        {
          customer: this.state.selectedSubCategoryData.customer?.replace(
            /&/g,
            "%26"
          ),
          l1: event.l1?.replace(/&/g, "%26"),
          l3: this.state.selectedSubCategoryData.l4?.replace(/&/g, "%26"),
          l4: event.l4?.replace(/&/g, "%26"),
          divisionId: this.state.divisionFilter,
          projectFlag: this.state.CustomerFilterSelectedValue.projectFlag,
          PeerGroupName: this.state.PeerGroupName,
        },
        event
      );
    }
  };

  isRowHighlightedRequired = (isRequired: any) => {
    this.setState({
      isRowHighlighted: isRequired,
    });
  };

  handleClick = (data: any) => {
    this.getUpSellLevelFourRecommendationData({
      customer: this.state.crossSellOpportunityData.id,
      l4: data.levelValue?.replace(/&/g, "%26"),
      itemId: data.ItemNo?.replace(/&/g, "%26"),
      divisionId: this.state.divisionFilter,
    });

    this.setState({
      selectedLFourValue: data.levelValue?.replace(/&/g, "%26"),
    });
  };

  // save the checked/unchecked data here
  dataToBeSave = (data: any) => {
    if (this.arrayToBeUsed.length === 0) this.arrayToBeUsed.push(data);
    else {
      for (let i = 0; i < this.arrayToBeUsed.length; i++) {
        if (
          this.arrayToBeUsed[i].itemNo === data.itemNo &&
          this.arrayToBeUsed[i].include !== data.include
        )
          this.arrayToBeUsed.push(data);
      }
    }
  };

  handleTabSelect = (isUpSell: boolean) => {
    if (this.state.isUpSell !== isUpSell) {
      if (isUpSell) {
        this.getCrossSellTotalCount(
          this.state.CustomerFilterSelectedValue,
          isUpSell
        );
        this.getCustomerList(
          this.state.CustomerFilterSelectedValue.customer,
          this.state.CustomerFilterSelectedValue.peerGroupName,
          this.state.CustomerFilterSelectedValue.projectFlag,
          this.state.pageSize,
          this.state.PageNumber,
          this.state.order,
          this.state.orderBy,
          isUpSell
        );
        this.setState({
          crossSellOpportunityData: null,
          crossSellItemList: [],
          recAcceptedObj: {},
          powerBiSelectedCustomer: "",
          selectedSubCategoryData: null,
          peerItemLevelData: {},
          divisionFilter: [],
        });
        this.clickedCustomerData = null;
        this.setExpendedRowArray();
      } else {
        this.getCrossSellTotalCount(
          this.state.CustomerFilterSelectedValue,
          isUpSell
        );
        this.getCustomerList(
          this.state.CustomerFilterSelectedValue.customer,
          this.state.CustomerFilterSelectedValue.peerGroupName,
          this.state.CustomerFilterSelectedValue.projectFlag,
          this.state.pageSize,
          this.state.PageNumber,
          this.state.order,
          this.state.orderBy,
          isUpSell
        );
        this.setState({
          upSellOpportunityData: null,
          upSellRecommendedData: null,
          upSellLevelFourRecommendedData: null,
          divisionFilter: [],
        });
        this.clickedCustomerData = null;
        this.setExpendedRowArray();
      }
      this.setState({
        isUpSell: isUpSell,
      });
      this.isRowHighlightedRequired(false);
    }
  };

  resettingValueWithIncludeBitForUpSell = (event: any, index: any) => {
    let data = JSON.parse(JSON.stringify(this.state.tableData));

    let recItemList = this.state.upSellLevelFourRecommendedData;
    let recUpSellOpoortunity = this.state.upSellOpportunityData;
    recItemList.data[index].IsIncluded = event.target.checked ? 1 : 0;
    let totalQuantity = 0;
    let totalCurrentPortfolio = 0;
    let totalAditionalMarginOpportunity = 0;
    data?.list[this.clickedCustomerIndex]?.list?.forEach((d: any) => {
      if (d.l4 == this.state.selectedLFourValue) {
        if (event.target.checked) {
          d = this.calculateUpSellUnits(recItemList, d);
        } else {
          d = this.calculateUpSellUnits(recItemList, d);
        }
      }
      totalQuantity += d.quantity;
      totalCurrentPortfolio += d.currentPortfolio;
      totalAditionalMarginOpportunity += d.aditionalMarginOpportunity;
    });
    data.list[this.clickedCustomerIndex].total.additionalMarginOpp =
      totalAditionalMarginOpportunity;
    data.list[this.clickedCustomerIndex].total.revenue = totalCurrentPortfolio;
    data.list[this.clickedCustomerIndex].total.quantity = totalQuantity;
    recUpSellOpoortunity = this.calculateAdjustedOpportunity(
      recUpSellOpoortunity,
      data.list[this.clickedCustomerIndex].total
    );
    this.setState({
      tableData: data,
      upSellLevelFourRecommendedData: recItemList,
      upSellOpportunityData: recUpSellOpoortunity,
    });
  };

  calculateAdjustedOpportunity = (recUpSellOpoortunity: any, totalObj: any) => {
    recUpSellOpoortunity.opportunity.sales.adjustedState =
      totalObj.currentRevenue + totalObj.revenue;
    recUpSellOpoortunity.opportunity.price.adjustedState =
      (totalObj.currentRevenue + totalObj.revenue) /
      (totalObj.quantity + totalObj.currentVolume);
    recUpSellOpoortunity.opportunity.margin.adjustedState =
      (totalObj.marginOpp + totalObj.additionalMarginOpp) /
      (totalObj.quantity + totalObj.currentVolume);
    return recUpSellOpoortunity;
  };

  calculateUpSellUnits = (recItemList: any, d: any) => {
    let quantity = 0;
    let currentPortfolio = 0;
    let aditionalMarginOpportunity = 0;
    recItemList.data.forEach((recItem: any) => {
      if (recItem.IsIncluded) {
        quantity += recItem.potentialVolume;
        currentPortfolio += recItem.Revenue;
        aditionalMarginOpportunity += recItem.Margin;
      }
    });
    d.quantity = quantity;
    d.currentPortfolio = currentPortfolio;
    d.aditionalMarginOpportunity = aditionalMarginOpportunity;
    return d;
  };

  handleCheckChange = (event: any, index: number) => {
    let data = JSON.parse(JSON.stringify(this.state.newTableData));
    let subCategorySelected = JSON.parse(
      JSON.stringify(this.state.selectedSubCategoryData)
    );
    data.list[this.clickedCustomerIndex].isAccept = false;
    let recItemList = this.state.crossSellItemList;
    let value = Math.round(Number(recItemList[index].quantity));
    let weightedSumLikelihood = 0;
    let weightedSumPeers = 0;
    let sum = 0;
    recItemList[index].include = event.target.checked ? 1 : 0;
    data.list[this.clickedCustomerIndex].list.forEach((d: any) => {
      if (d.l4 === subCategorySelected.l4) {
        d.isAccept = false;
        if (event.target.checked) {
          d.quantity += value;
          d.currentPortfolio += value * recItemList[index].price;
          d.marginOpportunity += value * recItemList[index].margin;

          subCategorySelected.quantity += value;
          subCategorySelected.currentPortfolio += Math.round(
            value * recItemList[index].price
          );
          subCategorySelected.marginOpportunity += Math.round(
            value * recItemList[index].margin
          );
          data.list[this.clickedCustomerIndex].total.quantity += value;
          data.list[this.clickedCustomerIndex].total.marginOpp +=
            value * recItemList[index].margin;
          data.list[this.clickedCustomerIndex].total.revenue +=
            value * recItemList[index].price;
        } else {
          d.quantity -= value;
          d.currentPortfolio -= value * recItemList[index].price;
          d.marginOpportunity -= value * recItemList[index].margin;

          subCategorySelected.quantity -= value;
          subCategorySelected.currentPortfolio -= Math.round(
            value * recItemList[index].price
          );
          subCategorySelected.marginOpportunity -= Math.round(
            value * recItemList[index].margin
          );
          data.list[this.clickedCustomerIndex].total.quantity -= value;
          data.list[this.clickedCustomerIndex].total.marginOpp -=
            value * recItemList[index].margin;
          data.list[this.clickedCustomerIndex].total.revenue -=
            value * recItemList[index].price;
        }
        recItemList.forEach((d: any) => {
          if (d.include === 1) {
            weightedSumLikelihood += Number(d.quantity) * d.likelihoodOfBuying;
            weightedSumPeers += Number(d.quantity) * d.peersBuying;
            sum += Number(d.quantity);
          }
        });

        this.clickedCustomerData = data.list[this.clickedCustomerIndex];
      }
    });

    let l4dataforChange = JSON.parse(JSON.stringify(this.state.l4Data));
    let selectedl4DataforChange = JSON.parse(
      JSON.stringify(this.state.selectedL4Data)
    );
    let currentPortfolioforl4 = 0;
    l4dataforChange.list.forEach((l4Local: any) => {
      if (l4Local.l4 === selectedl4DataforChange.l4) {
        recItemList.forEach((d: any) => {
          if (d.include === 1) {
            currentPortfolioforl4 += d.price * d.quantity;
          }
        });
        l4Local.currentPortfolio = currentPortfolioforl4;
        l4dataforChange.currentPortfolio = currentPortfolioforl4;
      }
    });
    const obj = {
      likelihoodOfBuying: Math.round((weightedSumLikelihood / sum) * 100) || 0,
      peersBuying: Math.round((weightedSumPeers / sum) * 100) || 0,
    };
    this.setState({
      itemsTotal: {
        initialQuantity: subCategorySelected.quantity,
        initialNetSales: subCategorySelected.currentPortfolio,
        initialNetMargin: subCategorySelected.marginOpportunity,
        quantity: this.state.itemsTotal.quantity,
        netSales: this.state.itemsTotal.netSales,
        netMargin: this.state.itemsTotal.netMargin,
      },
      newTableData: data,
      l4Data: l4dataforChange,
      crossSellOpportunityData: this.clickedCustomerData,
      crossSellItemList: recItemList,
      selectedSubCategoryData: subCategorySelected,
      peerItemLevelData: obj,
    });
    this.createRequestPayload(subCategorySelected, recItemList[index]);
  };
  handlePriceChange = (event: any, item: any, index: number) => {
    let value = event.target.value;
    let recItemList = this.state.crossSellItemList;
    recItemList[index].price = parseFloat(event.target.value);
    let initialSalesValue = 0;
    let initialMargValue = 0;
    let selectedSubcategory = JSON.parse(
      JSON.stringify(this.state.selectedSubCategoryData)
    );
    let initialpeerRowdata = JSON.parse(JSON.stringify(this.state.itemsTotal));
    let prodctPerQuantity = initialpeerRowdata.quantity;
    let prodctPerSales = initialpeerRowdata.netSales;
    let prodctPerMargin = initialpeerRowdata.netMargin;
    if (!isNaN(value) && item.include === 1 && event.target.value !== "") {
      recItemList.forEach((d: any) => {
        if (d.include === 1) {
          d.margin = d.price - Number(d.cost);
          initialSalesValue += d.price * Number(d.quantity);
          initialMargValue += d.margin * Number(d.quantity);
        }
      });

      let sum: number = 0;
      recItemList.forEach((d: any) => {
        if (d.include === 1) {
          sum += d.quantity;
        }
      });
      let data = JSON.parse(JSON.stringify(this.state.newTableData));
      data.totalOpp -= data.list[this.clickedCustomerIndex].total.marginOpp;
      let currentPortfolioValue = 0;
      let marginOppValue = 0;
      let customerTotal = {
        quantity: 0,
        revenue: 0,
        marginOpp: 0,
      };
      data.list[this.clickedCustomerIndex].list.forEach((itemLocal: any) => {
        if (
          selectedSubcategory.l4 === itemLocal.l4 &&
          selectedSubcategory.location === itemLocal.location
        ) {
          let filterdData = this.state?.l4Data?.list.filter(($: any) => {
            return $?.l4 !== this.state.selectedL4Data.l4;
          });

          if (filterdData?.length !== 0) {
            filterdData.forEach((value: any) => {
              currentPortfolioValue += value?.currentPortfolio;
              sum += value?.quantity;
            });
          }
          recItemList.forEach((d: any) => {
            if (d.include === 1) {
              currentPortfolioValue += d.price * d.quantity;
              marginOppValue += d.margin * d.quantity;
            }
          });
          itemLocal.quantity = sum;
          itemLocal.currentPortfolio = currentPortfolioValue;
          itemLocal.marginOpportunity = marginOppValue;
        }
        customerTotal.quantity += itemLocal.quantity;
        customerTotal.revenue += itemLocal.currentPortfolio;
        customerTotal.marginOpp += itemLocal.marginOpportunity;
      });
      let l4dataforChange = JSON.parse(JSON.stringify(this.state.l4Data));
      let selectedl4DataforChange = JSON.parse(
        JSON.stringify(this.state.selectedL4Data)
      );
      let currentPortfolioforl4 = 0;
      l4dataforChange.list.forEach((l4Local: any) => {
        if (l4Local.l4 === selectedl4DataforChange.l4) {
          recItemList.forEach((d: any) => {
            if (d.include === 1) {
              currentPortfolioforl4 += d.price * d.quantity;
            }
          });
          l4Local.currentPortfolio = currentPortfolioforl4;
          l4dataforChange.currentPortfolio = currentPortfolioforl4;
        }
      });
      selectedSubcategory.quantity = sum;
      selectedSubcategory.currentPortfolio = currentPortfolioValue;
      selectedSubcategory.marginOpportunity = marginOppValue;
      initialMargValue = data.list[this.clickedCustomerIndex].total.marginOpp;
      Object.assign(data.list[this.clickedCustomerIndex].total, customerTotal);
      this.clickedCustomerData = data.list[this.clickedCustomerIndex];
      data.totalOpp += data.list[this.clickedCustomerIndex].total.marginOpp;
      this.setState({
        itemsTotal: {
          initialQuantity: prodctPerQuantity,
          initialNetSales: initialSalesValue,
          initialNetMargin: initialMargValue,
          quantity: prodctPerQuantity,
          netSales: prodctPerSales,
          netMargin: prodctPerMargin,
        },
        selectedL4Data: selectedl4DataforChange,
        l4Data: l4dataforChange,
        newTableData: data,
        crossSellOpportunityData: this.clickedCustomerData,
        selectedSubCategoryData: selectedSubcategory,
        crossSellItemList: recItemList,
      });
    }
  };

  handleVolumeChangeNew = (event: any, item: any, index: number) => {
    let value = event.target.value;
    let recItemList = this.state.crossSellItemList;
    recItemList[index].quantity = parseInt(event.target.value);
    let initialSum: number = 0;
    let initialNetSales = 0;
    let initialMarginOppValue = 0;
    let selectedSubcategory = JSON.parse(
      JSON.stringify(this.state.selectedSubCategoryData)
    );
    let initialpeerRowdata = JSON.parse(JSON.stringify(this.state.itemsTotal));
    let prodctPerQuantity = initialpeerRowdata.quantity;
    let prodctPerSales = initialpeerRowdata.netSales;
    let prodctPerMargin = initialpeerRowdata.netMargin;
    if (!isNaN(value) && item.include === 1 && event.target.value !== "") {
      recItemList.forEach((d: any) => {
        if (d.include === 1) {
          initialSum += Number(d.quantity);
          initialNetSales += d.price * Number(d.quantity);
          initialMarginOppValue += d.margin * Number(d.quantity);
        }
      });
      let sum: number = 0;
      recItemList.forEach((d: any) => {
        if (d.include === 1) {
          sum += d.quantity;
        }
      });
      let data = JSON.parse(JSON.stringify(this.state.newTableData));
      data.totalOpp -= data.list[this.clickedCustomerIndex].total.marginOpp;
      let selectedSubcategory = JSON.parse(
        JSON.stringify(this.state.selectedSubCategoryData)
      );
      let currentPortfolioValue = 0;
      let marginOppValue = 0;
      let customerTotal = {
        quantity: 0,
        revenue: 0,
        marginOpp: 0,
      };
      data.list[this.clickedCustomerIndex].list.forEach((itemLocal: any) => {
        if (
          selectedSubcategory.l4 === itemLocal.l4 &&
          selectedSubcategory.location === itemLocal.location
        ) {
          let filterdData = this.state?.l4Data?.list.filter(($: any) => {
            return $?.l4 !== this.state.selectedL4Data.l4;
          });

          if (filterdData?.length !== 0) {
            filterdData.forEach((value: any) => {
              currentPortfolioValue += value?.currentPortfolio;
              sum += value?.quantity;
            });
          }

          recItemList.forEach((d: any) => {
            if (d.include === 1) {
              currentPortfolioValue += d.price * d.quantity;
              marginOppValue += d.margin * d.quantity;
            }
          });
          itemLocal.quantity = sum;
          itemLocal.currentPortfolio = currentPortfolioValue;
          itemLocal.marginOpportunity = marginOppValue;

          // this.state?.newTableData?.list?.forEach(($:any) => {
          //     console.log($?.id,itemLocal?.customer,0)
          //     console.log($,1)
          //     if($?.id==itemLocal?.customer){
          //         console.log($,2)
          //         // $?.list?.forEach((value:any)=>{
          //         //     value.currentPortfolio=currentPortfolioValue
          //         // })
          //     }
          // });
        }
        customerTotal.quantity += itemLocal.quantity;
        customerTotal.revenue += itemLocal.currentPortfolio;
        customerTotal.marginOpp += itemLocal.marginOpportunity;
      });
      let l4dataforChange = JSON.parse(JSON.stringify(this.state.l4Data));
      let selectedl4DataforChange = JSON.parse(
        JSON.stringify(this.state.selectedL4Data)
      );
      let currentPortfolioforl4 = 0;
      l4dataforChange.list.forEach((l4Local: any) => {
        if (l4Local.l4 === selectedl4DataforChange.l4) {
          recItemList.forEach((d: any) => {
            if (d.include === 1) {
              currentPortfolioforl4 += d.price * d.quantity;
            }
          });
          l4Local.currentPortfolio = currentPortfolioforl4;
          l4dataforChange.currentPortfolio = currentPortfolioforl4;
        }
      });
      selectedl4DataforChange.currentPortfolio = currentPortfolioforl4;
      selectedSubcategory.quantity = sum;
      selectedSubcategory.currentPortfolio = currentPortfolioValue;
      selectedSubcategory.marginOpportunity = marginOppValue;
      initialMarginOppValue =
        data.list[this.clickedCustomerIndex].total.marginOpp;
      Object.assign(data.list[this.clickedCustomerIndex].total, customerTotal);
      this.clickedCustomerData = data.list[this.clickedCustomerIndex];
      data.totalOpp += data.list[this.clickedCustomerIndex].total.marginOpp;
      this.setState(
        {
          itemsTotal: {
            initialQuantity: initialSum,
            initialNetSales: initialNetSales,
            initialNetMargin: initialMarginOppValue,
            quantity: prodctPerQuantity,
            netSales: prodctPerSales,
            netMargin: prodctPerMargin,
          },
          selectedL4Data: selectedl4DataforChange,
          l4Data: l4dataforChange,
          newTableData: data,
          crossSellOpportunityData: this.clickedCustomerData,
          selectedSubCategoryData: selectedSubcategory,
          crossSellItemList: recItemList,
        },
        () => {
          this.createRequestPayload(
            this.state.selectedSubCategoryData,
            recItemList[index]
          );
        }
      );
    }
  };

  createRequestPayload = (summaryData: any, itemData: any) => {
    let summaryKeyUnique =
      summaryData.customer + "_" + summaryData.l4 + "_" + summaryData.location;
    let itemKeyUnique =
      summaryData.customer + "_" + itemData.itemId + "_" + itemData.l4;
    this.saveRequestPayload.summary[summaryKeyUnique] = {
      customer: summaryData.customer,
      l4: summaryData.l4,
      adjustedQuantity: summaryData.quantity,
      adjustedCurrentPortfolio: summaryData.currentPortfolio,
      adjustedMarginOpportunity: summaryData.marginOpportunity,
      location: summaryData.location,
    };
    this.saveRequestPayload.item[itemKeyUnique] = {
      customer: summaryData.customer,
      l4: itemData.l4,
      itemId: itemData.itemId,
      quantity: itemData.quantity,
      price: itemData.price,
      include: itemData.include,
    };
  };

  submitCrossSellExecution = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    putAPI("/submitCrossSellRecommendation", payload)
      .then(() => {
        this.setState({
          pageLoading: false,
        });
        // Alert.success("Data submitted successfully");
      })
      .catch((error: any) => {
        console.log(error);
        this.setState({
          pageLoading: false,
        });
        // Alert.success("Some error occurred");
      });
  };

  handleSave = () => {
    // appInsights.trackEvent({ name: "SAVE on recommended Qty or Price" });
    if (Object.values(this.saveRequestPayload.summary).length) {
      this.setState({
        pageLoading: true,
      });
      this.saveRequestPayload.summary = Object.values(
        this.saveRequestPayload.summary
      );
      this.saveRequestPayload.item = Object.values(
        this.saveRequestPayload.item
      );
      putAPI("/saveCrossSellItemVolume", {
        ...this.saveRequestPayload,
        userEmail: this.state.userEmail,
      })
        .then(() => {
          this.setState({
            pageLoading: false,
          });
          this.saveRequestPayload = {
            summary: {},
            item: {},
          };
          // Alert.success("Data updated successfully");
        })
        .catch((error: any) => {
          console.log(error);
          this.setState({
            pageLoading: false,
          });
          // Alert.success("Some error occurred");
        });
    } else {
      // Alert.info("No changes to be saved");
    }
  };

  prepareExportData = (data: any) => {
    let obj = {},
      finalData: any = [];

    if (data?.length !== 0) {
      data?.forEach((value: any) => {
        // console.log("datatatatata" ,value.OpportunityRevenue);
        obj = {
          purchase_item: value?.itemIdBrought_BroughtDesc.split("_")[0],
          purchase_itemDesc: value?.itemIdBrought_BroughtDesc.split("_")[1],
          gotogether_item: value?.itemId_Desc.split("_")[0],
          gotogether_itemDesc: value?.itemId_Desc.split("_")[1],
          l3: value?.l3,
          l4: value?.l4,
          price: `$ ${value?.price?.toFixed(2)}`,
          margin: `$ ${value?.margin?.toFixed(2)}`,
          quantity: value?.quantity,
          cost: `$ ${value?.cost}`,
          OpportunityRevenue: `$ ${value?.OpportunityRevenue}`,
          OpportunityMargin: `$ ${value?.OpportunityMargin}`,
        };

        finalData.push(obj);
      });

      this.setState({
        exportData: finalData,
      });
    }
  };

  handleItems = () => {
    this.setState({
      pageLoading: true,
    });
    // appInsights.trackEvent({ name: "get gotogether list" });
    getCrossSellItemsByCustomerOrItem({
      district: this.state.selectedDistrict,
      customer: this.state.selectedCustomersList,
      itemBrought: this.state.selectedItemIdBought,
      itemId: this.state.selectedRecommendedItemIdBought,
      userEmail: this.state.userEmail,
    })
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          this.setState({
            GoTogetherItemList: response.data.data,
            itemsTotal: response.data.data.total,
            openModal: true,
          });

          this.prepareExportData(response.data.data);
        }
      })
      .catch((err: any) => {
        console.log("error in getCustomerList APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  /* Function to get all customers and itemBrought ids in popup */
  getFilters = () => {
    this.setState({
      pageLoading: true,
    });
    // appInsights.trackEvent({ name: "get filter list" });
    getCrossSellFiltersData({userEmail : this.state.userEmail})
    // getCrossSellFiltersData()
      .then((response: any) => {
        this.setState({
          pageLoading: false,
        });
        if (response.status === 200 && response.data) {
          [
            this.masterCustomers,
            this.masterSKU,
            this.masterRecommendedSKU,
            this.masterData,
          ] = [
            response.data.customer,
            response.data.itemIdBrought,
            response.data.itemId,
            response.data.masterData,
          ];
          this.setState({
            allCustomers: response.data.customer,
            allItemId: response.data.itemIdBrought,
            allDistricts: response.data.districts,
            allRecommendedItemId: response.data.itemId,
            openModal: true,
          });
          // this.handleItems();
        }
      })
      .catch((err: any) => {
        console.log("error in getCrossSellFilterData APi --", err);
        this.setState({
          pageLoading: false,
        });
      });
  };

  handleFilterChange = (value: any, entity: string) => {
    // this.setState({
    //     pageLoading: true
    // })

    if (entity == "district") {
      let filterdCustomers =
        value.length > 0
          ? [
              ...new Set(
                this.masterData
                  .filter((data: any) => value.includes(data.location))
                  .map((i: any) => i.customerId_desc)
              ),
            ].map((i) => ({ label: i, value: i }))
          : this.masterCustomers;
      let filteredSKUs =
        value.length > 0
          ? [
              ...new Set(
                this.masterData
                  .filter((data: any) => value.includes(data.location))
                  .map((i: any) => i.itemIdBrought_BroughtDesc)
              ),
            ].map((i) => ({ label: i, value: i }))
          : this.masterSKU;

      let recommFilteredSKUs =
        value.length > 0
          ? [
              ...new Set(
                this.masterData
                  .filter((data: any) => value.includes(data.location))
                  .map((i: any) => i.itemId_Desc)
              ),
            ].map((i) => ({ label: i, value: i }))
          : this.masterRecommendedSKU;

      this.setState(
        {
          selectedDistrict: value,
          selectedCustomersList: [],
          selectedItemIdBought: [],
          selectedRecommendedItemIdBought: [],
          allCustomers: filterdCustomers,
          allItemId: filteredSKUs,
          allRecommendedItemId: recommFilteredSKUs,
          GoTogetherItemList: [],
        },
        () => {
          // this.handleItems();
        }
      );
    } else if (entity == "customer") {
      let filteredSKUs = [];
      let recommFilteredSKUs = [];
      if (this.state.selectedDistrict.length > 0) {
        filteredSKUs = [
          ...new Set(
            this.masterData
              .filter(
                (data: any) =>
                  (value.length > 0
                    ? value.includes(data.customerId_desc)
                    : true) &&
                  this.state.selectedDistrict.includes(data.location)
              )
              .map((i: any) => i.itemIdBrought_BroughtDesc)
          ),
        ].map((i) => ({ label: i, value: i }));

        recommFilteredSKUs = [
          ...new Set(
            this.masterData
              .filter(
                (data: any) =>
                  (value.length > 0
                    ? value.includes(data.customerId_desc)
                    : true) &&
                  this.state.selectedDistrict.includes(data.location)
              )
              .map((i: any) => i.itemId_Desc)
          ),
        ].map((i) => ({ label: i, value: i }));
      } else {
        filteredSKUs =
          value.length > 0
            ? [
                ...new Set(
                  this.masterData
                    .filter((data: any) => value.includes(data.customerId_desc))
                    .map((i: any) => i.itemIdBrought_BroughtDesc)
                ),
              ].map((i) => ({ label: i, value: i }))
            : this.masterSKU;

        recommFilteredSKUs =
          value.length > 0
            ? [
                ...new Set(
                  this.masterData
                    .filter((data: any) => value.includes(data.customerId_desc))
                    .map((i: any) => i.itemId_Desc)
                ),
              ].map((i) => ({ label: i, value: i }))
            : this.masterRecommendedSKU;
      }
      this.setState(
        {
          selectedCustomersList: value,
          selectedItemIdBought: [],
          selectedRecommendedItemIdBought: [],
          allItemId: filteredSKUs,
          allRecommendedItemId: recommFilteredSKUs,
          GoTogetherItemList: [],
        },
        () => {
          // this.handleItems();
        }
      );
    } else if (entity == "item") {
      this.setState({
        pageLoading: true,
      });
      if (value.length > 0) {
        this.setState(
          {
            selectedItemIdBought: value,
          },
          () => {
            this.handleItems();
          }
        );
      } else {
        this.setState({
          selectedItemIdBought: value,
          GoTogetherItemList: [],
          pageLoading: false,
        });
      }
    } else if (entity == "recommendedItem") {
      this.setState({
        pageLoading: true,
      });

      if (value.length > 0) {
        this.setState(
          {
            selectedRecommendedItemIdBought: value,
          },
          () => {
            this.handleItems();
          }
        );
      } else {
        this.setState({
          selectedRecommendedItemIdBought: value,
          GoTogetherItemList: [],
          pageLoading: false,
        });
      }
      // this.setState({
      //     selectedRecommendedItemIdBought: value
      // }, () => {
      //     this.handleItems();
      // })
    }
  };

  submitUpSellSellExecution = (payload: any) => {
    this.setState({
      pageLoading: true,
    });
    putAPI("/submitUpSellRecommendation", payload)
      .then(() => {
        this.setState({
          pageLoading: false,
        });
        // Alert.success("Data submitted successfully");
      })
      .catch((error: any) => {
        console.log(error);
        this.setState({
          pageLoading: false,
        });
        // Alert.success("Some error occurred");
      });
  };

  removeItemAll = (arr: any, value: any) => {
    var i = 0;
    while (i < arr.length) {
      if (arr[i].location !== value) {
        arr.splice(i, 1);
      } else {
        ++i;
      }
    }
    return arr;
  };

  handleDivisionChange = (value: any) => {
    if (value === null) {
      this.setState({
        divisionFilter: [],
      });
      if (this.state.isUpSell) {
        this.getUpSellRecommendationTableData({
          customer: this.clickedCustomerData.id,
        });
        this.getUpSellOpportunities({ customer: this.clickedCustomerData.id });
        this.setState({
          upSellLevelFourRecommendedData: null,
          tableData: this.state.backupTableData,
        });
      } else {
        this.clickedCustomerData = this.backupClickedCustomerData;
        this.setState({
          tableData: this.state.backupTableData,
          crossSellOpportunityData: this.clickedCustomerData,
          crossSellItemList: [],
          selectedSubCategoryData: null,
        });
      }
    } else {
      this.setState(
        {
          divisionFilter: [value],
        },
        () => {
          if (this.state.isUpSell) {
            this.getUpSellRecommendationTableData(
              { customer: this.clickedCustomerData.id },
              this.state.divisionFilter
            );
            this.getUpSellOpportunities(
              { customer: this.clickedCustomerData.id },
              this.state.divisionFilter
            );
            this.setState({
              upSellLevelFourRecommendedData: null,
            });
          } else {
            let manipulatedList = JSON.parse(
              JSON.stringify(this.clickedCustomerData)
            );
            // manipulatedList.listOld = this.backupTableData;
            manipulatedList["list"] = this.removeItemAll(
              manipulatedList.list,
              value
            );
            this.setState({
              crossSellOpportunityData: manipulatedList,
              crossSellItemList: [],
              selectedSubCategoryData: null,
            });
          }
        }
      );
    }
  };

  handleReset = () => {};
  handleSubmit = () => {};
  handleRuleChange = () => {};

  setGoBackLinkValue = (val: boolean) => {
    this.setState({
      isGoBackLinkVisible: val,
    });
  };
  allTogetherListHeaders: any = {
    itemId: "Item Id",
    itemDesc: "Description",
    l3: "L3",
    l4: "L4",
    quantity: "Recommended Quantity (eaches/year)",
    price: "Price ($/each)",
    margin: "Margin ($/each)",
  };
  convertToCSV(headers: any[], data: any): string {
    // const array = typeof jsonObject !== "object" ? JSON.parse(jsonObject) : jsonObject;
    const header = Object.keys(data[0])
      .map((key) => `"${key}"`)
      .join(",");
    const rows = data.map(
      (obj: { [s: string]: unknown } | ArrayLike<unknown>) =>
        Object.values(obj)
          .map((value) => `"${value}"`)
          .join(",")
    );
    return `${header}\n${rows.join("\n")}`;
  }

  exportData = () => {
    this.setState({
      pageLoading: true,
    });
    let columns: any;
    if (this.state.rootTabActive === "buyer") {
      columns =
        this.state.tabActive === "existing"
          ? this.state.commodityExportSelection
          : this.state.nonCommodityExportSelection;
    } else {
      columns = this.state.salesRepExportSelection;
    }
    if (columns?.length) {
      const finalHeaders: any = {};
      Object.keys(this.allTogetherListHeaders).forEach((d: any) => {
        if (columns.includes(d)) {
          finalHeaders[d] = this.allTogetherListHeaders[d];
        }
      });
      this.allTogetherListHeaders = finalHeaders;
    }
    // Object.keys(this.allTogetherListHeaders).forEach((key: string) => {
    //     this.checkHeaderToggle(this.allTogetherListHeaders, key);
    // });
    // if (header) {
    //     items.unshift(header);
    // }

    // Convert Object to JSON
    const exportedFilenmae = "export.csv";
    const jsonString = JSON.stringify(this.state.GoTogetherItemList);
    const jsonObject = JSON.parse(jsonString);
    const csv = this.convertToCSV(this.allTogetherListHeaders, jsonObject);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    // if (navigator.msSaveBlob) { // IE 10+
    //     navigator.msSaveBlob(blob, exportedFilenmae);
    // } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    this.setState({
      pageLoading: false,
    });
    // }
  };

  manageDataReflection = (event: any, data: any, index: any) => {
    let currentItemid = this.state.saveRecommendation?.itemid || [];
    let currentSummary = this.state.saveRecommendation?.summary || [];

    let itemid: any = [],
      summary: any = [],
      obj1 = {},
      obj2 = {},
      customer = this.clickedCustomerData?.id,
      found = false,
      found2 = false;

    currentItemid?.forEach(($: any) => {
      if ($?.itemId === data?.itemId) {
        found = true;
        $.include = data?.include;
        $.price = data?.price;
        $.quantity = data?.quantity;
        $.adjustedItemMarginOpportunity = data?.adjustedmarginOpportunity;
        $.adjustedOpportunityRevenue = data?.adjustedOpportunityRevenue;
      }
    });

    if (!found) {
      obj1 = {
        itemId: data?.itemId,
        include: data?.include,
        quantity: data?.quantity,
        price: data?.price,
        customer: customer,
        l4: data?.l4,
        prevQuantity: Math.round(data?.adjustedQuantity),
        prevPrice: data?.copyPrice,
        adjustedItemMarginOpportunity: data?.adjustedmarginOpportunity,
        adjustedOpportunityRevenue: data?.adjustedOpportunityRevenue,
      };
      currentItemid.push(obj1);
    }

    let found1 = this.clickedCustomerData?.list?.find(
      ($: any) => $?.l4 === data?.l3
    );
    if (found1) {
      currentSummary?.forEach(($: any) => {
        if ($?.l3 === data?.l3) {
          found2 = true;
          $.adjustedQuantity = found1?.quantity;
          $.adjustedCurrentPortfolio = found1?.currentPortfolio;
          $.adjustedMarginOpportunity = found1?.marginOpportunity;
        }
      });

      if (!found2) {
        obj2 = {
          adjustedQuantity: found1?.quantity,
          adjustedCurrentPortfolio: found1?.currentPortfolio,
          adjustedMarginOpportunity: found1?.marginOpportunity,
          customer: found1?.customer,
          l3: found1?.l4,
          l4: data?.l4,
          location: found1?.location,
        };
        currentSummary.push(obj2);
      }
    }

    let filterData = currentItemid.filter(
      ($: any) =>
        ($?.quantity !== $?.prevQuantity || $?.price !== $?.prevPrice) &&
        $?.include === 1
    );
    filterData?.forEach(($: any) => {
      $.location = found1?.location;
    });

    // currentSummary?.forEach(($:any)=>{
    //     if($?.l4===data?.l3){
    //     found1=true
    //         $.include=data?.include
    //         $.price=data?.price
    //         $.quantity=data?.quantity
    //     }
    // })

    // if(!found1){
    //     obj2={
    //         adjustedQuantity:,
    //         adjustedCurrentPortfolio:,
    //         adjustedMarginOpportunity:,
    //         customer:,
    //         l4:,
    //         location:,
    //     }
    //     currentItemid.push(obj1)
    // }

    this.setState({
      saveRecommendation: {
        itemid: filterData,
        summary: currentSummary,
      },
    });
  };

  saveRecommendationHandle = () => {
    this.setState({
      pageLoading: true,
    });
    saveCrossSellItemVolume(this.state?.saveRecommendation)
      .then((response: any) => {
        if (response?.status === 200) {
          this.clickedCustomerData = null;
          this.backupClickedCustomerData = null;
          this.clickedCustomerIndex = null;
          this.setState({
            crossSellOpportunityData: null,
            crossSellItemList: [],
            selectedSubCategoryData: null,
            filteredList: null,
            divisionFilter: [],
            itemsTotal: {},
            isRowHighlighted: false,
          });
          this.getCrossSellTotalCount(
            this.state.CustomerFilterSelectedValue,
            this.state.isUpSell
          );
          this.getCustomerList(
            this.state.CustomerFilterSelectedValue.customer,
            this.state.CustomerFilterSelectedValue.peerGroupName,
            this.state.CustomerFilterSelectedValue.projectFlag,
            this.state.pageSize,
            this.state.PageNumber,
            this.state.order,
            this.state.orderBy,
            this.state.isUpSell
          );
        }
        this.setState({
          pageLoading: false,
        });
      })
      .catch((err: any) => {
        this.setState({
          pageLoading: false,
        });
      });
  };
  render(): React.ReactNode {
    const {
      tableData,
      newTableData,
      powerBiSelectedCustomer,
      divisionData,
      pageLoading,
      enableSave,
      tableHeight,
      isUpSell,
      peerItemLevelData,
      divisionFilter,
      setBackToOriginalData,
      CustomerFilterValue,
      PeerFilterValue,
      crossSellOpportunityData,
      exportData,
      crossSellItemList,
      recAcceptedObj,
      selectedSubCategoryData,
      itemsTotal,
      l4Data,
      selectedL4Data,
      openModal,
      GoTogetherItemList,
      allCustomers,
      allItemId,
      selectedCustomersList,
      selectedItemIdBought,
      allDistricts,
      selectedDistrict,
      allRecommendedItemId,
      selectedRecommendedItemIdBought,
      saveRecommendation,
    } = this.state;
    return (
      <>
        {pageLoading && <div className="loaderCustom"></div>}
        <div className="crossSellComponent">
          <Title
            isGoBackLinkVisible={this.state.isGoBackLinkVisible}
            setGoBackLinkValue={this.setGoBackLinkValue}
            powerBiSelectedCustomer={powerBiSelectedCustomer}
          />

          <Row className="filter-container">
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  overflow: "hidden",
                  width: "28%",
                  textAlign: "left",
                  fontSize: "10px",
                  padding: "0px 16px",
                }}
              >
                <p>Project Type</p>
                <SelectPicker
                  preventOverflow={true}
                  appearance="default"
                  cleanable={false}
                  size="xs"
                  onChange={(value: any) => {
                    this.setState({
                      CustomerFilterSelectedValue: {
                        ...this.state.CustomerFilterSelectedValue,
                        projectFlag: value ? [value] : ["NonProject"],
                        peerGroupName: [],
                        customer: [],
                      },
                    });
                  }}
                  onExit={() => {
                    if (
                      this.state.CustomerFilterSelectedValue.projectFlag.length
                    ) {
                      this.getCustomerFilterList();
                      this.handleFilterTable();
                      this.isRowHighlightedRequired(false);
                      this.isUpSellRowHighlightingRequired(true);
                    }
                    this.setState({
                      crossSellItemList: [],
                      selectedSubCategoryData: null,
                      crossSellOpportunityData: null,
                    });
                  }}
                  onClean={() => {
                    this.setState({
                      crossSellItemList: [],
                      selectedSubCategoryData: null,
                      crossSellOpportunityData: null,
                      CustomerFilterSelectedValue: {
                        ...this.state.CustomerFilterSelectedValue,
                        projectFlag: ["NonProject"],
                      },
                    });
                    this.getCrossSellTotalCount([], this.state.isUpSell);
                    this.getCustomerList(
                      [],
                      [],
                      ["NonProject"],
                      10,
                      1,
                      this.state.order,
                      this.state.orderBy,
                      false
                    );
                  }}
                  menuStyle={{
                    background: "gray",
                    color: "white",
                    width: "100px",
                    fontSize: "1em",
                    zIndex: 9999,
                  }}
                  disabled={pageLoading}
                  labelKey="label"
                  valueKey="value"
                  // searchable={false}
                  // placeholder={'Customer'}
                  value={this.state.CustomerFilterSelectedValue.projectFlag[0]}
                  data={[
                    { label: "Project", value: "Project" },
                    { label: "Non Project", value: "NonProject" },
                  ]}
                  // defaultValue={SelectedCustomerFilter}
                  // value={SelectedCustomerFilter}
                  renderMenuItem={(label: any) => {
                    return (
                      <div title={label} key={label}>
                        <i /> {label}
                      </div>
                    );
                  }}
                  style={{ width: "100%", background: "gray", color: "white" }}
                />
              </div>
              <div
                style={{
                  overflow: "hidden",
                  width: "28%",
                  textAlign: "left",
                  fontSize: "10px",
                  padding: "0px 16px",
                }}
              >
                <p>Peer Group</p>
                <CheckPicker
                  preventOverflow={true}
                  appearance="default"
                  size="xs"
                  onChange={(value: any) => {
                    this.setState({
                      CustomerFilterSelectedValue: {
                        ...this.state.CustomerFilterSelectedValue,
                        initialCustomer: [],
                        customer: [],
                        peerGroupName: value,
                        initialPeerGroupName:
                          this.state.CustomerFilterSelectedValue.peerGroupName,
                      },
                    });
               
                  }}
                  onExit={() => {
                    if (
                      JSON.stringify(
                        this.state.CustomerFilterSelectedValue.peerGroupName
                      ) !==
                      JSON.stringify(
                        this.state.CustomerFilterSelectedValue
                          .initialPeerGroupName
                      )
                    ) {
                      this.getCustomerFilterList();
                      this.handleFilterTable();
                      this.isRowHighlightedRequired(false);
                      this.isUpSellRowHighlightingRequired(true);
                    }
                   
                    this.setState({
                      crossSellItemList: [],
                      selectedSubCategoryData: null,
                      crossSellOpportunityData: null,
                    });
                  }}
                  onClean={() => {
                    this.setState(
                      {
                        crossSellItemList: [],
                        selectedSubCategoryData: null,
                        crossSellOpportunityData: null,
                        // CustomerFilterSelectedValue : [],
                        CustomerFilterSelectedValue: {
                          ...this.state.CustomerFilterSelectedValue,
                          peerGroupName: [],
                        },
                      },
                      () => {
                        this.getCustomerFilterList();
                        this.getCrossSellTotalCount(
                          this.state.CustomerFilterSelectedValue,
                          this.state.isUpSell
                        );
                        this.getCustomerList(
                          [],
                          [],
                          [
                            this.state.CustomerFilterSelectedValue
                              .projectFlag[0],
                          ],
                          10,
                          1,
                          this.state.order,
                          this.state.orderBy,
                          false
                        );
                      }
                    );
                  }}
                  menuStyle={{
                    background: "gray",
                    color: "white",
                    width: "100px",
                    fontSize: "1em",
                    zIndex: 9999,
                  }}
                  disabled={pageLoading}
                  labelKey="label"
                  valueKey="value"
                  // searchable={false}
                  // placeholder={'Customer'}
                  value={this.state.CustomerFilterSelectedValue.peerGroupName}
                  data={PeerFilterValue}
                  // defaultValue={SelectedCustomerFilter}
                  // value={SelectedCustomerFilter}
                  renderMenuItem={(label: any) => {
                    return (
                      <div title={label} key={label}>
                        <i /> {label}
                      </div>
                    );
                  }}
                  style={{ width: "100%", background: "gray", color: "white" }}
                />
              </div>
              <div
                style={{
                  overflow: "hidden",
                  width: "28%",
                  textAlign: "left",
                  fontSize: "10px",
                  padding: "0px 16px",
                }}
              >
                <p>Customer</p>
                <CheckPicker
                  preventOverflow={true}
                  appearance="default"
                  size="xs"
                  onChange={(value: any) => {
                    this.setState({
                      CustomerFilterSelectedValue: {
                        ...this.state.CustomerFilterSelectedValue,
                        customer: value,
                        initialCustomer:
                          this.state.CustomerFilterSelectedValue.customer,
                        peerGroupName:
                          this.state.CustomerFilterSelectedValue.peerGroupName,
                      },
                    });
                  }}
                  onExit={(context) => {
                    if (
                      JSON.stringify(
                        this.state.CustomerFilterSelectedValue.customer
                      ) !==
                      JSON.stringify(
                        this.state.CustomerFilterSelectedValue.initialCustomer
                      )
                    ) {
                      this.getCustomerFilterList();
                      this.handleFilterTable();
                      this.isRowHighlightedRequired(false);
                      this.isUpSellRowHighlightingRequired(true);
                    }

                    if (
                      this.state.CustomerFilterSelectedValue.customer.length > 0
                    ) {
                      this.setState({
                        crossSellItemList: [],
                        selectedSubCategoryData: null,
                        crossSellOpportunityData: null,
                      });
                    } else {
                      this.setState({
                        crossSellItemList: [],
                        // selectedSubCategoryData: null,
                        // crossSellOpportunityData: null,
                      });
                    }
                  }}
                  onClean={() => {
                    this.setState(
                      {
                        crossSellItemList: [],
                        selectedSubCategoryData: null,
                        crossSellOpportunityData: null,
                        CustomerFilterSelectedValue: {
                          ...this.state.CustomerFilterSelectedValue,
                          customer: [],
                          peerGroupName:
                            this.state.CustomerFilterSelectedValue
                              .peerGroupName,
                        },
                      },
                      () => {
                        this.getCustomerFilterList();
                        this.getCrossSellTotalCount(
                          this.state.CustomerFilterSelectedValue,
                          this.state.isUpSell
                        );
                        this.getCustomerList(
                          [],
                          this.state.CustomerFilterSelectedValue.peerGroupName,
                          [
                            this.state.CustomerFilterSelectedValue
                              .projectFlag[0],
                          ],
                          10,
                          1,
                          this.state.order,
                          this.state.orderBy,
                          false
                        );
                      }
                    );
                  }}
                  menuStyle={{
                    background: "gray",
                    color: "white",
                    width: "100px",
                    fontSize: "1em",
                    zIndex: 9999,
                  }}
                  disabled={pageLoading}
                  labelKey="label"
                  valueKey="value"
                  // searchable={false}
                  // placeholder={'Customer'}
                  value={this.state.CustomerFilterSelectedValue.customer}
                  data={CustomerFilterValue}
                  // defaultValue={SelectedCustomerFilter}
                  // value={SelectedCustomerFilter}
                  renderMenuItem={(label: any) => {
                    return (
                      <div title={label} key={label}>
                        <i /> {label}
                      </div>
                    );
                  }}
                  style={{ width: "100%", background: "gray", color: "white" }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "end",
                width: "100%",
              }}
            >
              <Col
                className="subHead"
                xs={24}
                sm={24}
                md={18}
                style={{ textAlign: "end" }}
              >
                {crossSellOpportunityData && (
                  <div style={{display: 'flex' , justifyContent : 'end', width : '100%' ,    paddingRight: '4.3vh'}}>
                    <div style={{display : 'flex' , width : '100%'}}>
                    <label style={{ display:'flex',width : '100%' , justifyContent : 'end',  color: "#ffffff" }}>
                      Customer - {crossSellOpportunityData.name}
                    </label>
                    <label style={{ color: "#ffffff" ,display: 'none' , justifyContent : 'end', width : '35%'}}>
                      District - {``}
                      <SelectPicker
                        searchable={false}
                        preventOverflow={true}
                        appearance="default"
                        size="xs"
                        onChange={(value: any) =>
                          this.handleDivisionChange(value)
                        }
                        menuStyle={{
                          background: "gray",
                          color: "white",
                          width: "100px",
                          fontSize: "1em",
                          zIndex: "999",
                        }}
                        placeholder={
                          divisionFilter.length
                            ? "Division " + divisionFilter[0]
                            : "All"
                        }
                        data={divisionData}
                        value={
                          divisionFilter.length ? divisionFilter[0] : "All"
                        }
                        renderMenuItem={(label: any) => {
                          return (
                            <div title={label}>
                              <i /> {label}
                            </div>
                          );
                        }}
                        style={{
                          width: "42%",
                          background: "gray",
                          color: "white",
                        }}
                      />
                    </label>
                    </div>
                   
                    <Col xs={24} sm={24} md={3}>
                      <Button
                        className="buttonMargin"
                        color="green"
                        style={{
                          color: "white",
                          marginLeft: "8px",
                          fontSize: "0.7vw",
                        }}
                        onClick={() => this.getFilters()}
                        appearance="default"
                      >
                        GoTogether List
                      </Button>
                    </Col>
                  </div>
                )}
              </Col>
            </div>
          </Row>
          <Row className="show-grid">
            <Col xs={24} sm={24} md={1} />
            <Col
              className="subHead "
              xs={20}
              sm={24}
              md={9}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
              }}
            >
              {
                <>
                  <span
                    style={{
                      fontWeight: !isUpSell ? 400 : "inherit",
                      lineHeight: !isUpSell ? 1.5 : "inherit",
                      fontSize: "0.63vw",
                    }}
                    onClick={() => this.handleTabSelect(false)}
                    className={isUpSell ? "normalCross" : "highlightCross"}
                  >
                    <label style={{ fontSize: "0.8vw" }}>Cross-Sell</label>
                    {!isUpSell
                      ? " (Customers: " +
                        this.state.totalCount +
                        ", Margin Opportunity: $" +
                        Math.round(
                          Math.round((this.state.totalOpp / 1000) * 10) / 10
                        )
                          .toString()
                          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") +
                        "K)"
                      : ""}
                  </span>
                </>
              }
              {/* OLD PLACEMENT OF CUSTOMER FILTER */}
              {/* <div
                style={{
                  overflow: "hidden",
                  width: "100%",
                  textAlign: "left",
                  fontSize: "16px",
                  padding: "0px 16px",
                }}
              >
                <p>Customer</p>
                <CheckPicker
                  preventOverflow={true}
                  appearance="default"
                  size="xs"
                  onChange={(value: any) => {

                    this.setState({
                      CustomerFilterSelectedValue: value,
                    });
                  }}
                  onExit={() => {
                    if (this.state.CustomerFilterSelectedValue.length !== 0) {
                      console.log("called");
                      this.handleFilterTable()
                      this.isRowHighlightedRequired(false);
                      this.isUpSellRowHighlightingRequired(true);
                    }
                    this.setState({
                      crossSellItemList: [],
                      selectedSubCategoryData: null,
                      crossSellOpportunityData: null,
                    })
                  }}
                  onClean={() => {


                    this.setState({
                      crossSellItemList: [],
                      selectedSubCategoryData: null,
                      crossSellOpportunityData: null,
                      CustomerFilterSelectedValue: [],
                    });
                    console.log(
                      this.state.CustomerFilterSelectedValue,
                      "sdsffdf"
                    );
                    this.getCrossSellTotalCount([], this.state.isUpSell);
                    this.getCustomerList(
                      [],
                      10,
                      1,
                      this.state.order,
                      this.state.orderBy,
                      false
                    );
                  }}
                  menuStyle={{
                    background: "gray",
                    color: "white",
                    width: "100px",
                    fontSize: "1em",
                    zIndex: 9999,
                  }}
                  disabled={pageLoading}
                  labelKey="label"
                  valueKey="value"
                  // searchable={false}
                  // placeholder={'Customer'}
                  value={this.state.CustomerFilterSelectedValue}
                  data={CustomerFilterValue}
                  // defaultValue={SelectedCustomerFilter}
                  // value={SelectedCustomerFilter}
                  renderMenuItem={(label: any) => {
                    return (
                      <div title={label} key={label}>
                        <i /> {label}
                      </div>
                    );
                  }}
                  style={{ width: "100%", background: "gray", color: "white" }}
                />
              </div> */}
            </Col>

            <Col
              style={{
                marginBottom: "0.5%",
                paddingBottom: "0%",
                color: "#ffffff",
                textAlign: "end",
                paddingRight: '5.3vh',
                fontSize: "1rem",
              }}
              className="subHeadCU subHeadCS"
              xs={24}
              sm={24}
              md={14}
            >
              {this.clickedCustomerData && crossSellOpportunityData && (
                <>
                  <span
                    style={{
                      fontSize: "0.8em",
                      marginLeft: "1%",
                      marginRight: "1%",
                      color: "white",
                    }}
                  >
                    Customer Cross-Sell Opportunity
                    <span
                      className="recommendLegend"
                      style={{ marginLeft: "0.2rem" }}
                    ></span>
                    Current Portfolio
                  </span>
                  <span
                    style={{
                      fontSize: "0.8em",
                      marginRight: "1%",
                      color: "white",
                    }}
                  >
                    <span
                      style={{ background: "#e6f5c6" }}
                      className="recommendLegend"
                    ></span>
                    Cross-Sell Opportunity
                  </span>
                </>
              )}
            </Col>
          </Row>
          <Row className="show-grid crossMain">
            <Col xs={24} sm={24} md={1}></Col>
            <Col
              className="greenBorder"
              style={{ height: '65vh', marginRight: "25px" }}
              xs={24}
              sm={24}
              md={9}
            >
              <Table
                powerBiSelectedCustomer={powerBiSelectedCustomer}
                handleBCISubmit={this.handleBCISubmit}
                handleModify={this.handleModify}
                handleRecAccept={this.handleRecAccept}
                handleRecReject={this.handleRecReject}
                isRowHighlightedRequired={this.isRowHighlightedRequired}
                isRowHighlighted={this.state.isRowHighlighted}
                handleRecChanges={this.handleRecChanges}
                handleReset={this.handleReset}
                sortObj={this.sortObj}
                sortFn={this.sortFnLocal}
                enableSave={enableSave}
                handleSave={this.handleSubmit}
                data={newTableData}
                handleRowClick={this.handleTableRowClick}
                handleRuleChange={this.handleRuleChange}
                isUpSell={isUpSell}
                setExpendedRowArray={this.setExpendedRowArray}
                expandedRows={this.state.expendedRow}
                totalPages={this.state.totalCount}
                handlePaginationAPI={this.handlePaginationAPI}
                setPayloadVariables={this.setPayloadVariables}
              />
            </Col>
            {/* <Col xs={24} sm={24} md={1}></Col> */}

            <Col
              style={{ height: '65vh', overflow: "auto" }}
              xs={24}
              sm={24}
              md={13}
            >
              <div style={{ display: "flex" }}>
                <Row
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    height: "15vh",
                    overflow: "auto",
                  }}
                  id="graph"
                  className="show-grid greenBorder"
                >
                  {isUpSell ? (
                    <UpSellOpportunity
                      data={this.state.upSellOpportunityData}
                      adjustPositionValue={this.state.adjustPositionValue}
                    />
                  ) : (
                    <>
                      <CrossSellOpportunity
                        handleCheckChange={this.handleCheckChange}
                        handleVolumeChangeNew={this.handleVolumeChangeNew}
                        setBackToOriginalData={setBackToOriginalData}
                        selectedSubCategory={selectedSubCategoryData}
                        data={crossSellOpportunityData}
                        handleSubCategoryClick={this.handleL3Click}
                        clickedCustomerData={this.clickedCustomerData}
                      />
                    </>
                  )}
                </Row>

                {!isUpSell && (
                  <Row
                    style={{
                      padding: "0 !important",
                      width: "100%",
                      height: "15vh",
                    }}
                    className="show-grid greenBorder"
                  >
                    <Col xs={24} sm={24} md={24}>
                      <CrossSellOpportunityL4
                        selectedSubCategory={selectedSubCategoryData}
                        data={l4Data}
                        selectedL4Data={selectedL4Data}
                        handleSubCategoryClick={this.handleSubCategoryClick}
                        clickedCustomerData={this.clickedCustomerData}
                      />
                      {/* <PeerBenchmarking data={itemsTotal} peerItemLevelData={peerItemLevelData} productClass={selectedSubCategoryData} /> */}
                    </Col>
                  </Row>
                )}
              </div>

              {!isUpSell && (
                <Row style={{ height: "0.6vh" }} className="show-grid">
                  <Col xs={24} sm={24} md={24}></Col>
                </Row>
              )}
              <Row
                style={{ height: isUpSell ? "62%" : "49.4vh" }}
                className="show-grid greenBorder"
              >
                {isUpSell ? (
                  <UpSellRecommendation
                    data={this.state.upSellRecommendedData}
                    handleClick={this.handleClick}
                    setAdjustPoistionIconValue={this.setAdjustPoistionIconValue}
                    levelFourData={this.state.upSellLevelFourRecommendedData}
                    dataToBeSave={this.dataToBeSave}
                    handleUpSellSave={this.handleUpSellSave}
                    submitUpSellSellExecution={this.submitUpSellSellExecution}
                    selectedL4Value={this.state.selectedLFourValue}
                    customerId={this.state.crossSellOpportunityData?.id}
                    isUpSellRowHighlightingRequired={
                      this.isUpSellRowHighlightingRequired
                    }
                    isUpSellRowHighlighted={this.state.isUpSellRowHighlighted}
                    resettingValueWithIncludeBitForUpSell={
                      this.resettingValueWithIncludeBitForUpSell
                    }
                  />
                ) : (
                  <CrossSellRecommendation
                    handleCheckChange={this.handleCheckChange}
                    submitRefresh={() =>
                      this.getCustomerList(
                        this.state.CustomerFilterSelectedValue.customer,
                        this.state.CustomerFilterSelectedValue.peerGroupName,
                        this.state.CustomerFilterSelectedValue.projectFlag,
                        this.state.pageSize,
                        this.state.PageNumber,
                        this.state.order,
                        this.state.orderBy,
                        this.state.isUpSell,
                        false
                      )
                    }
                    saveRecommendationHandle={this.saveRecommendationHandle}
                    saveRecommendation={saveRecommendation}
                    handleVolumeChangeNew={this.handleVolumeChangeNew}
                    acceptedData={recAcceptedObj}
                    data={crossSellItemList}
                    manageDataReflection={this.manageDataReflection}
                    handleSave={this.handleSave}
                    submitCrossSellExecution={this.submitCrossSellExecution}
                    handlePriceChange={this.handlePriceChange}
                  />
                )}
              </Row>
            </Col>
            {/* <Col xs={24} sm={24} md={1}></Col> */}
          </Row>
        </div>
        {openModal && (
          <Modal
            open={openModal}
            onClose={() =>
              this.setState({
                selectedCustomersList: [],
                selectedItemIdBought: [],
              })
            }
          >
            <Box className="modalClass">
              <div style={{ position: "relative", marginBottom: "0.5rem" }}>
                <h3 className="text-center" style={{ fontSize: "1.2rem" }}>
                  Recommended Items
                </h3>
                <span
                  onClick={() => this.setState({ openModal: false })}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    cursor: "pointer",
                  }}
                >
                  &#10006;
                </span>
              </div>
              <div className="filter-flex">
                <div>
                  <p>District</p>
                  <CheckPicker
                    preventOverflow={true}
                    appearance="default"
                    size="xs"
                    onChange={(value: any) =>
                      this.handleFilterChange(value, "district")
                    }
                    menuStyle={{
                      background: "gray",
                      color: "white",
                      width: "100px",
                      fontSize: "1em",
                      zIndex: 9999,
                    }}
                    disabled={pageLoading}
                    // searchable={false}
                    placeholder={"District"}
                    data={allDistricts}
                    labelKey="label"
                    valueKey="value"
                    defaultValue={selectedDistrict}
                    value={selectedDistrict}
                    renderMenuItem={(label: any) => {
                      return (
                        <div title={label} key={label}>
                          <i /> {label}
                        </div>
                      );
                    }}
                    style={{
                      width: "100%",
                      background: "gray",
                      color: "white",
                    }}
                  />
                </div>
                <div>
                  <p>Customer</p>
                  <CheckPicker
                    preventOverflow={true}
                    appearance="default"
                    size="xs"
                    onChange={(value: any) => {
                      this.handleFilterChange(value, "customer");
                    }}
                    menuStyle={{
                      background: "gray",
                      color: "white",
                      width: "100px",
                      fontSize: "1em",
                      zIndex: 9999,
                    }}
                    disabled={pageLoading}
                    labelKey="label"
                    valueKey="value"
                    // searchable={false}
                    placeholder={"Customer"}
                    data={allCustomers}
                    defaultValue={selectedCustomersList}
                    value={selectedCustomersList}
                    renderMenuItem={(label: any) => {
                      return (
                        <div title={label} key={label}>
                          <i /> {label}
                        </div>
                      );
                    }}
                    style={{
                      width: "100%",
                      background: "gray",
                      color: "white",
                    }}
                  />
                </div>
                <div>
                  <p>Purchased Item ID</p>
                  <CheckPicker
                    preventOverflow={true}
                    appearance="default"
                    size="xs"
                    onChange={(value: any) =>
                      this.handleFilterChange(value, "item")
                    }
                    menuStyle={{
                      background: "gray",
                      color: "white",
                      width: "100px",
                      fontSize: "1em",
                      zIndex: 9999,
                    }}
                    disabled={pageLoading}
                    // searchable={false}
                    placeholder={"Purchased ItemId"}
                    data={allItemId}
                    labelKey="label"
                    valueKey="value"
                    defaultValue={selectedItemIdBought}
                    value={selectedItemIdBought}
                    renderMenuItem={(label: any) => {
                      return (
                        <div title={label} key={label}>
                          <i /> {label}
                        </div>
                      );
                    }}
                    style={{
                      width: "100%",
                      background: "gray",
                      color: "white",
                    }}
                  />
                </div>
                <div>
                  <p>Recommended Item ID</p>
                  <CheckPicker
                    preventOverflow={true}
                    appearance="default"
                    size="xs"
                    onChange={(value: any) =>
                      this.handleFilterChange(value, "recommendedItem")
                    }
                    menuStyle={{
                      background: "gray",
                      color: "white",
                      width: "100px",
                      fontSize: "1em",
                      zIndex: 9999,
                    }}
                    disabled={pageLoading}
                    // searchable={false}
                    placeholder={"Recommended ItemId"}
                    data={allRecommendedItemId}
                    labelKey="label"
                    valueKey="value"
                    defaultValue={selectedRecommendedItemIdBought}
                    value={selectedRecommendedItemIdBought}
                    renderMenuItem={(label: any) => {
                      return (
                        <div title={label} key={label}>
                          <i /> {label}
                        </div>
                      );
                    }}
                    style={{
                      width: "100%",
                      background: "gray",
                      color: "white",
                    }}
                  />
                </div>
              </div>
              <CrossSellAllTogetherList
                exportData={exportData}
                data={GoTogetherItemList}
                handleClose={() => this.setState({ openModal: false })}
              />
            </Box>
          </Modal>
        )}
      </>
    );
  }
}
